import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {mb, mt} from "@pg-design/helpers-css";
import {BrandMedalIcon} from "@pg-design/icons-module";
import {getTextVariantStyleFor} from "@pg-design/text";
import {Text} from "@pg-design/text-module";

import {anniversaryPGLink} from "../../../navigation/constants/links";
import {getVendorAnniversaryAwardPrice} from "../../helpers/VendorAnniversaryAwardType";

interface IProps {
    vendorId: number;
    vendorName: string;
}

export const AnniversaryAwards = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={anniversaryAwardsWrapperStyle}>
            <Text as="h2" variant="headline_3" css={[anniversaryAwardsHeader]}>
                Nagrody Jubileuszowe
            </Text>

            <div css={anniversaryAwardsBodyStyle}>
                <p css={[mt(0), mb(2)]}>
                    {props.vendorName} otrzymał nagrodę w kategorii <span>{getVendorAnniversaryAwardPrice(props.vendorId)}</span>
                </p>
                <a href={anniversaryPGLink} css={anniversaryLinkStyle}>
                    Dowiedz się więcej
                </a>
            </div>
            <div css={anniversaryAwardsIcon}>
                <BrandMedalIcon size="4" wrapperSize="4" wrapperColor={theme.colors.primary} css={hideOnDesktop} />
                <BrandMedalIcon size="10" wrapperSize="10" wrapperColor={theme.colors.primary} css={hideOnMobile} />
            </div>
        </div>
    );
};

const anniversaryAwardsWrapperStyle = (theme: Theme) => css`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: auto 5rem;
    grid-template-areas: "header icon" "body body";
    width: 100%;

    @media (min-width: ${theme.breakpoints.md}) {
        grid-template-areas: "header icon" "body icon";
        grid-template-columns: auto 10rem;
    }
`;

const anniversaryAwardsHeader = (theme: Theme) => css`
    grid-area: header;
    align-self: center;

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(3)};
    }
`;

const anniversaryAwardsBodyStyle = (theme: Theme) => css`
    grid-area: body;
    ${getTextVariantStyleFor("body_copy_2")(theme)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${getTextVariantStyleFor("headline_5")(theme)};
    }
`;

const anniversaryAwardsIcon = (theme: Theme) => css`
    grid-area: icon;
    justify-self: end;
    align-self: center;

    ${mb(1)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(0)};
    }
`;

const hideOnMobile = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.numeric.md - 1}px) {
        display: none;
    }
`;

const hideOnDesktop = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;

const anniversaryLinkStyle = (theme: Theme) => css`
    color: ${theme.colors.gray["700"]};
    text-decoration: underline;
    ${getTextVariantStyleFor("body_copy_1")(theme)};
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {mb, mt} from "@pg-design/helpers-css";
import {BrandMedalIcon} from "@pg-design/icons-module";
import {getTextVariantStyleFor} from "@pg-design/text";
import {Text} from "@pg-design/text-module";

import {anniversaryPGLink} from "../../../navigation/constants/links";
import {getVendorAnniversaryAwardPrice} from "../../helpers/VendorAnniversaryAwardType";

interface IProps {
    vendorId: number;
    vendorName: string;
}

export const AnniversaryAwards = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={anniversaryAwardsWrapperStyle}>
            <Text as="h2" variant="headline_3" css={[anniversaryAwardsHeader]}>
                Nagrody Jubileuszowe
            </Text>

            <div css={anniversaryAwardsBodyStyle}>
                <p css={[mt(0), mb(2)]}>
                    {props.vendorName} otrzymał nagrodę w kategorii <span>{getVendorAnniversaryAwardPrice(props.vendorId)}</span>
                </p>
                <a href={anniversaryPGLink} css={anniversaryLinkStyle}>
                    Dowiedz się więcej
                </a>
            </div>
            <div css={anniversaryAwardsIcon}>
                <BrandMedalIcon size="4" wrapperSize="4" wrapperColor={theme.colors.primary} css={hideOnDesktop} />
                <BrandMedalIcon size="10" wrapperSize="10" wrapperColor={theme.colors.primary} css={hideOnMobile} />
            </div>
        </div>
    );
};

const anniversaryAwardsWrapperStyle = (theme: Theme) => css`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: auto 5rem;
    grid-template-areas: "header icon" "body body";
    width: 100%;

    @media (min-width: ${theme.breakpoints.md}) {
        grid-template-areas: "header icon" "body icon";
        grid-template-columns: auto 10rem;
    }
`;

const anniversaryAwardsHeader = (theme: Theme) => css`
    grid-area: header;
    align-self: center;

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(3)};
    }
`;

const anniversaryAwardsBodyStyle = (theme: Theme) => css`
    grid-area: body;
    ${getTextVariantStyleFor("body_copy_2")(theme)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${getTextVariantStyleFor("headline_5")(theme)};
    }
`;

const anniversaryAwardsIcon = (theme: Theme) => css`
    grid-area: icon;
    justify-self: end;
    align-self: center;

    ${mb(1)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(0)};
    }
`;

const hideOnMobile = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.numeric.md - 1}px) {
        display: none;
    }
`;

const hideOnDesktop = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;

const anniversaryLinkStyle = (theme: Theme) => css`
    color: ${theme.colors.gray["700"]};
    text-decoration: underline;
    ${getTextVariantStyleFor("body_copy_1")(theme)};
`;
